import { singleRunPromise } from '../common/adapter'
import { showModal } from '../pageApi/tip'
import { ref } from 'vue'
import { convertInitialToUppercase } from '@/common/object'

const httpError = Symbol('http error')

const commonErrorModal = {}

export default class HttpResult {
  Code
  Message
  ErrorCode
  Data
  ModifyTime

  _error

  constructor(obj, isDownload) {
    if (isDownload) {
      if (obj[1]) {
        this.Data = obj[1].data
        this.Code = 0
      }
    } else {
      if (obj[1]) Object.assign(this, convertInitialToUppercase(obj[1].data))
    }
    if (obj[0]) this._error = obj[0]
  }

  /**
   * 处理网络异常提示，不终止代码
   * @param {*} param0
   */
  async error({ onOk, onCancel, complete }) {
    if (this._error) {
      const res = await singleRunPromise(httpError, async () => {
        return await showModal({
          icon: 'error',
          title: '网络错误',
          content: '请求数据失败,请重试'
        })
      })

      if (res.confirm && onOk) {
        await onOk()
      }
      if (res.cancel && onCancel) {
        await onCancel()
      }
      if (complete) complete()
      console.error(this._error)
    }
    if (complete) complete()
  }

  /**
   * 异常提示，不终止代码
   * @param {*} param0
   */
  async errorContinue({ title, onOk, onCancel, complete }) {
    await this.errorStop({ title, onOk, onCancel, complete, throwError: false })
  }

  /**
   * 异常终止并提示
   * @param {*} param0
   */
  async errorStop({ title, onOk, onCancel, complete, throwError = true }) {
    await this.error({ onOk, complete })

    if (this.Code != 0) {
      if ([103, 106].includes(this.Code)) {
        await this.showModalCode({ code: this.Code, title: title || '操作失败', content: this.Message, icon: 'error' })
      } else {
        await showModal({ title: title || '操作失败', content: this.Message, icon: 'error' })
      }

      if (onOk) {
        await onOk()
      }
      if (onCancel) {
        await onCancel()
      }
      if (complete) complete()
      if (throwError) {
        console.error('errorStop', this._error)
        throw this._error
      }
    }
    if (complete) complete()
  }

  /**
   * 合并异常提示，不处理回调
   * @param {*} param0
   */
  async showModalCode({ code, title, content, icon }) {
    if (commonErrorModal[code]) {
      console.log(2)
      const modal = commonErrorModal[code].refModal.value
      const countRef = commonErrorModal[code].count
      const oldTitleRef = commonErrorModal[code].oldTitle
      const promise = commonErrorModal[code].promise
      oldTitleRef.value = `${oldTitleRef.value}、${title}`
      countRef.value++
      modal.update({
        title: oldTitleRef.value,
        content: `${content} （x ${countRef.value}）`
      })

      await promise
    } else {
      console.log(1)
      commonErrorModal[code] = { refModal: ref(), oldTitle: ref(title), count: ref(1) }
      commonErrorModal[code].promise = showModal({
        title: title,
        content: content,
        icon: icon,
        refModal: commonErrorModal[code].refModal
      }).then(() => {
        console.log(3)
        commonErrorModal[code] = undefined
      })
      await commonErrorModal[code].promise
    }
  }
}
